import React, {useState} from 'react';
import InputDateTime from "../../../../components/input/input-datetime.jsx";
import SelectComponent from "../../../../components/select/select-component.jsx";
import InputForm from "../../../../components/input/input-form.jsx";
import useFetchOptions from "../hooks/use-fetch-options.js";
import {minMenuHeight} from "../../../../components/reports/report-menu/menu.jsx";

const Filters = ({ setFilters, filters }) => {
    const { reportCodeOptions } = useFetchOptions();

    return (
        <>
            <div className={`mb-2 ${minMenuHeight}`}>
                <form className={'space-y-4'}>

                        <InputDateTime
                            id="dtStart"
                            label="Data/hora inicial *"
                            selected={filters.dtStart ? new Date(filters.dtStart) : null}
                            onChange={(date) => setFilters(prev => ({ ...prev, dtStart: date }))}
                            classNameWrapper={"w-full"}
                            dateFormat="LL"
                        />

                        <InputDateTime
                            id="dtEnd"
                            label="Data/hora final *"
                            selected={filters.dtEnd ? new Date(filters.dtEnd) : null}
                            onChange={(date) => setFilters(prev => ({ ...prev, dtEnd: date }))}
                            classNameWrapper={"w-full"}
                            dateFormat="LL"
                        />

                        <SelectComponent
                            label='Tipo do evento'
                            isMulti={true}
                            wrapValues={true}
                            options={reportCodeOptions}
                            value={filters.reportcode}
                            onChange={(value) => setFilters(prev => ({ ...prev, reportcode: value }))}
                            instanceId="reportcode"
                            classNameWrapper={"w-full"}
                        />

                        <InputForm
                            label="Descrição"
                            value={filters.description}
                            onChange={({target}) => setFilters(prev => ({ ...prev, description: target.value }))}
                            instanceId="description"
                            id="description"
                            classNameWrapper={"w-full"}
                            autocomplete={'off'}
                        />

                        <InputForm
                            label="Conta"
                            value={filters.account}
                            onChange={({target}) => setFilters(prev => ({ ...prev, account: target.value }))}
                            instanceId="account"
                            id="account"
                            classNameWrapper={"w-full"}
                            autocomplete={'off'}
                        />

                </form>
            </div>
        </>
    );
};

export default Filters;